// Header interactions (login dropdown, desktop menu hover-open, cart icon) moved out of sections/header.liquid (static, no Liquid) so it can be deferred and cached.

// Account login dropdown (open/close, outside-click, deep-link to /account tab)
document.addEventListener('DOMContentLoaded', function () {
  var login_account = document.querySelector('.login-account');
  var close_button = document.querySelector('.close_account_button');
  var dropDownContainer = document.querySelector('.dropdown-menu.LoginDrop');
  var dropdownLinks = document.querySelectorAll(
    '.dropdown-menu.LoginDrop li.dropdown-li .linkHover, .menu-drawer__utility-links .account-menu__link'
  );

  if (login_account) {
    login_account.addEventListener('click', function (event) {
      event.preventDefault();
      dropDownContainer.classList.toggle('show');
      if (dropDownContainer.classList.contains('show')) {
        document.body.classList.add('overflow-hidden');
      } else {
        document.body.classList.remove('overflow-hidden');
      }
    });
  }

  if (dropdownLinks) {
    dropdownLinks.forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault();
        var href = this.getAttribute('href');
        localStorage.setItem('lastClickedHref', href);
        window.location.href = '/account';
      });
    });
  }

  document.addEventListener('click', function (event) {
    if (dropDownContainer) {
      if (!dropDownContainer.contains(event.target) && !login_account.contains(event.target)) {
        dropDownContainer.classList.remove('show');
        document.body.classList.remove('overflow-hidden');
      }
    }
  });
  close_button?.addEventListener('click', function (event) {
    if (dropDownContainer) {
      dropDownContainer.classList.remove('show');
      document.body.classList.remove('overflow-hidden');
    }
  });

  var lastClickedHref = localStorage.getItem('lastClickedHref');
  if (lastClickedHref) {
    var profileLink = document.querySelector('.profile-navigation li a[href="#' + lastClickedHref + '"]');
    if (profileLink) {
      profileLink.click();
      localStorage.removeItem('lastClickedHref');
    }
  }
});

// Desktop inline menu: open the dropdown on hover, close on mouse leave
(function () {
    const inlineMenu = document.querySelector(".header__inline-menu");
    if (!inlineMenu) return;

    const items = inlineMenu.querySelectorAll("header-menu > details");

    const CLOSE_DELAY = 250;
    let closeTimer;

    const closeOthers = (except) => {
      items.forEach((detail) => {
        if (detail !== except) detail.removeAttribute("open");
      });
    };

    items.forEach((detail) => {
      const wrapper = detail.closest("header-menu") || detail;

      const openMenu = () => {
        clearTimeout(closeTimer);
        closeOthers(detail);
        detail.setAttribute("open", true);
      };

      const scheduleClose = () => {
        clearTimeout(closeTimer);
        closeTimer = setTimeout(() => detail.removeAttribute("open"), CLOSE_DELAY);
      };

      // Entering the summary (row 1) or, after crossing the wrapped row,
      // the mega-menu content (still a descendant of header-menu) both
      // fire mouseenter on the wrapper and cancel any pending close.
      wrapper.addEventListener("mouseenter", openMenu);
      wrapper.addEventListener("mouseleave", scheduleClose);
    });
  })();

// Header cart icon: open the cart drawer
const menuCartIcon = document.querySelector('.header__icon.header__icon--cart');
let cartDrawer = document.querySelector('cart-drawer.drawer');
if (menuCartIcon) {
  menuCartIcon.addEventListener('click', () => {
    setTimeout(() => {
      cartDrawer.classList.add('animate', 'active');
      document.body.classList.add('overflow-m-hidden');
    });
  });
}
